import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://bsjouvaamxewygdsbivg.supabase.co'
const supabaseKey = 'sb_publishable_FBnA5rcuBnXVBCre2JhlxQ_kIKrU_Ty'

export const supabase = createClient(supabaseUrl, supabaseKey)